/**
 * @flow
 */

import React from 'react';
import gql from 'graphql-tag';
import { Grid } from 'semantic-ui-react';
import { useQuery } from '@apollo/client';
import { useSelector } from 'react-redux';
import { get } from 'lodash';

import ReportSummary from './ReportSummary';
import ReportTable from './ReportTable';

export const GET_REPORT_QUERY = gql`
    query getReport(
        $fromDate: String!
        $toDate: String!
        $salonFilter: [ID]
        $masterFilter: [ID]
        $manufacturerFilter: [ID]
    ) {
        viewer {
            id
            ... on Supplier {
                report(
                    fromDate: $fromDate
                    toDate: $toDate
                    salonFilter: $salonFilter
                    masterFilter: $masterFilter
                    manufacturerFilter: $manufacturerFilter
                ) {
                    totalCount
                    revenue {
                        cash
                        total
                    }
                    items {
                        boughtAt
                        quantity
                        sum
                        entities {
                            quantity
                            sum
                            price
                            salon {
                                id
                                name
                                address
                            }
                            seller {
                                ... on Master {
                                    id
                                    firstName
                                    lastName
                                }
                                ... on Administrator {
                                    id
                                    firstName
                                    lastName
                                }
                            }
                            entity {
                                name
                                code
                                price
                                supplierPrice
                                manufacturer {
                                    id
                                    name
                                }
                                type
                            }
                        }
                    }
                }
            }
        }
    }
`;

const Report = () => {
    const fromDate = useSelector(({ report }) => report.get('fromDate'));
    const toDate = useSelector(({ report }) => report.get('toDate'));
    const salonFilter = useSelector(({ report }) => report.get('salonFilter'));
    const masterFilter = useSelector(({ report }) =>
        report.get('masterFilter'),
    );
    const manufacturerFilter = useSelector(({ report }) =>
        report.get('manufacturerFilter'),
    );

    const { loading, data } = useQuery(GET_REPORT_QUERY, {
        variables: {
            fromDate,
            toDate,
            salonFilter: salonFilter || [],
            masterFilter: masterFilter || [],
            manufacturerFilter: manufacturerFilter || [],
        },
        fetchPolicy: 'cache-and-network',
    });

    const { revenue, totalCount, items } = get(data, 'viewer.report', {});

    return (
        <Grid columns={1} padded>
            <Grid.Row>
                <Grid.Column>
                    <ReportSummary
                        loading={loading}
                        revenue={revenue}
                        totalCount={totalCount}
                    />
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column>
                    <ReportTable loading={loading} items={items} />
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
};

export default Report;
